class HeaderLinks extends HTMLElement {
  constructor() {
    super();
    this.cartButton = null;
    this.controller = new AbortController();
    this.cartCount = null;
    this.accountLink = null;
    this.accountLinkCustomer = null;
    this.accountLinkGuest = null;
  }

  connectedCallback() {
    this.cartCount = this.querySelector('[data-cart-count-desktop]');
    this.cartButton = this.querySelector('[data-cart-button]');
    this.accountLink = this.querySelector('[data-account-link]');
    if (this.accountLink) {
      this.accountLinkCustomer = this.accountLink.getAttribute('data-account-link-customer');
      this.accountLinkGuest = this.accountLink.getAttribute('data-account-link-guest');
      this.accountLinkIsCustomer = this.accountLink.getAttribute('data-account-link') === 'true';
    }

    if (this.cartButton) {
      this.cartButton.addEventListener('click', () => this.openCart(), {
        signal: this.controller.signal,
      });
    }

    if (this.cartCount) {
      document.addEventListener('cart:update-count', (e) => {
        const content = e.detail;
        if (content && typeof content.count === 'number') {
          try {
            this.cartCount.textContent = Number(content.count) > 0 ? `(${content.count})` : '';
          } catch (error) {
            this.cartCount.textContent = '';
          }
        }
      }, { signal: this.controller.signal });
    }
  }

  openCart() {
    // open cart drawer using dispatch event
    document.dispatchEvent(new CustomEvent('mobile-shopping-cart:open'));
  }

  disconnectedCallback() {
    if (this.controller) this.controller.abort();
  }
}

if (!customElements.get('header-links')) {
  customElements.define('header-links', HeaderLinks);
}
